module.exports = __webpack_public_path__ + "img/button2_0d040ae5f.png";